import { forwardRef, SVGProps } from 'react'

export const ErrorSvg = forwardRef<SVGSVGElement, SVGProps<string>>(
  ({ className }, ref) => (
    <svg
      viewBox="0 0 629 414"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M272.447 97.5355V263.835C272.447 278.262 260.752 289.958 246.325 289.958H114.407C99.9805 289.958 88.2852 278.262 88.2852 263.835V90.1223C88.2852 75.6953 99.9805 64 114.407 64H242.007"
        fill="#F1F3FA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M254.162 110.597V276.896C254.162 291.323 242.467 303.019 228.04 303.019H96.1223C81.6953 303.019 70 291.323 70 276.896V103.183C70 88.7564 81.6953 77.061 96.1223 77.061H223.722V80.9794L96.1223 80.9794C89.9908 80.9794 84.7573 83.1472 80.4217 87.4828C76.0861 91.8183 73.9183 97.0519 73.9183 103.183L73.9183 276.896C73.9183 283.028 76.0861 288.261 80.4217 292.597C84.7573 296.933 89.9908 299.1 96.1223 299.1H228.04C234.171 299.1 239.405 296.933 243.74 292.597C248.076 288.261 250.244 283.028 250.244 276.896V110.597H254.162Z"
        fill="#AAB2C5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M253.3 108.355C253.458 108.534 253.58 108.736 253.664 108.959C253.749 109.183 253.791 109.414 253.791 109.653C253.791 110.194 253.6 110.656 253.218 111.038C252.835 111.421 252.373 111.612 251.832 111.612H230.241C227.314 111.612 224.877 110.52 222.929 108.334C220.982 106.149 220.176 103.602 220.511 100.695L223.011 79.0357C223.039 78.7956 223.109 78.5684 223.22 78.3542C223.332 78.1399 223.479 77.9527 223.66 77.7926C223.854 77.6205 224.074 77.4922 224.32 77.4077C224.566 77.3232 224.818 77.2889 225.078 77.3048C225.337 77.3207 225.583 77.3857 225.817 77.4996C226.05 77.6136 226.253 77.7679 226.425 77.9625L253.3 108.355ZM226.401 83.8491L247.486 107.694H230.243C228.487 107.694 227.024 107.038 225.856 105.727C224.688 104.416 224.204 102.888 224.405 101.144L226.401 83.8491Z"
        fill="#AAB2C5"
      />
      <rect
        x="98.7344"
        y="117.551"
        width="78.3668"
        height="3.91834"
        rx="1.5"
        fill="#AAB2C5"
      />
      <rect
        x="98.7344"
        y="142.367"
        width="104.489"
        height="3.91834"
        rx="1.5"
        fill="#AAB2C5"
      />
      <rect
        x="98.7344"
        y="167.183"
        width="138.448"
        height="3.91834"
        rx="1.5"
        fill="#AAB2C5"
      />
      <rect
        x="98.7344"
        y="191.999"
        width="138.448"
        height="3.91834"
        rx="1.5"
        fill="#AAB2C5"
      />
      <rect
        x="98.7344"
        y="266.448"
        width="138.448"
        height="3.91834"
        rx="1.5"
        fill="#AAB2C5"
      />
      <rect
        x="98.7344"
        y="216.815"
        width="138.448"
        height="3.91834"
        rx="1.5"
        fill="#AAB2C5"
      />
      <rect
        x="98.7344"
        y="241.631"
        width="138.448"
        height="3.91834"
        rx="1.5"
        fill="#AAB2C5"
      />
      <path
        d="M45.8156 322.734H37.9688V386.774H45.8156V322.734Z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M101.503 322.734H93.6562V386.774H101.503V322.734Z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M550.467 329.822H543.633V386.015H550.467V329.822Z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M599.319 329.822H592.484V386.015H599.319V329.822Z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M607.926 332.353H536.039V355.387H607.926V332.353Z"
        fill="white"
        stroke="#FDBEBA"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
      />
      <path
        d="M545.17 333.071H552.512L545.392 354.669H538.287L545.17 333.071Z"
        fill="#FDBEBA"
        stroke="#FDBEBA"
        strokeWidth="1.43577"
      />
      <path
        d="M562.635 333.071H569.977L562.857 354.669H555.752L562.635 333.071Z"
        fill="#FDBEBA"
        stroke="#FDBEBA"
        strokeWidth="1.43577"
      />
      <path
        d="M580.1 333.071H587.442L580.321 354.669H573.217L580.1 333.071Z"
        fill="#FDBEBA"
        stroke="#FDBEBA"
        strokeWidth="1.43577"
      />
      <path
        d="M597.564 333.071H604.907L597.786 354.669H590.681L597.564 333.071Z"
        fill="#FDBEBA"
        stroke="#FDBEBA"
        strokeWidth="1.43577"
      />
      <path
        d="M111.376 325.771H29.3633V352.096H111.376V325.771Z"
        fill="white"
        stroke="#FDBEBA"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
      />
      <path
        d="M49.107 325.771L40.5008 351.843H30.6289L39.2351 325.771H49.107Z"
        fill="#FDBEBA"
      />
      <path
        d="M69.1031 325.771L60.4969 351.843H50.625L58.9781 325.771H69.1031Z"
        fill="#FDBEBA"
      />
      <path
        d="M89.0992 325.771L80.4929 351.843H70.6211L78.9742 325.771H89.0992Z"
        fill="#FDBEBA"
      />
      <path
        d="M109.095 325.771L100.489 351.843H90.6172L98.9703 325.771H109.095Z"
        fill="#FDBEBA"
      />
      <path
        d="M306 75L306 194"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M306.154 207.45C311.117 207.45 315.14 203.427 315.14 198.464C315.14 193.501 311.117 189.478 306.154 189.478C301.191 189.478 297.168 193.501 297.168 198.464C297.168 203.427 301.191 207.45 306.154 207.45Z"
        fill="#D6DCE8"
      />
      <path
        d="M297.422 222.384C297.422 227.953 302.484 232.509 308.559 230.991C311.85 230.231 314.381 227.7 315.141 224.409C316.153 219.6 313.369 215.044 309.066 213.778C307.547 213.272 306.534 212.006 306.534 210.234V202.387"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M524.729 378.421H428.035V386.268H524.729V378.421Z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M517.388 356.652H435.123L428.035 378.421H524.476L517.388 356.652Z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M554.598 44.8027V74.4183H277.68L304.511 47.334L554.598 44.8027Z"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M397.408 74.4183V47.334L366.527 74.4183V47.334L335.393 74.4183V47.334L304.512 74.4183V48.3465V47.334"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M521.438 74.4184V45.3091"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M428.543 47.334V74.4183L459.424 47.334"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M459.422 47.334V74.4183"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M492.835 343.996H459.676V17.2123L476.382 1.77173L492.835 17.2123V343.996Z"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M459.676 18.9844H492.835"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
      />
      <path
        d="M459.676 102.516H492.835"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M459.676 129.346H492.835"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
      />
      <path
        d="M459.676 155.924H492.835"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
      />
      <path
        d="M459.676 182.756H492.835"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
      />
      <path
        d="M459.676 209.587H492.835"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
      />
      <path
        d="M459.676 236.418H492.835"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
      />
      <path
        d="M459.676 262.996H492.835"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
      />
      <path
        d="M459.676 289.827H492.835"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
      />
      <path
        d="M459.676 316.658H492.835"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
      />
      <path
        d="M329.062 47.081L476.381 1.77173L546.496 45.056"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M459.422 74.4183L492.834 45.8152"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M491.821 75.4309L460.434 101.503"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M491.824 19.4902L460.184 44.8027"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M520.427 45.8152L494.102 73.912"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M522.199 73.912L554.346 45.8152"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M427.531 47.0806L398.422 73.1524"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M491.568 103.275L460.434 128.334"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M491.568 130.359L460.434 154.912"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M491.821 156.937L460.434 181.743"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M491.821 184.021L460.434 208.575"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M491.821 210.6L460.434 235.153"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M491.821 237.177L460.434 261.984"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M491.821 264.009L460.434 288.815"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M491.821 290.84L460.434 315.646"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M491.821 317.924L460.434 342.477"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M512.073 343.743H440.691V356.652H512.073V343.743Z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M252.379 236.725L299.813 227.288C303.289 226.543 306.766 227.288 309.498 229.026L346.004 250.135"
        stroke="#AAB2C5"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        opacity="0.1"
        d="M349.732 366.153L229.584 348.024C225.858 347.527 223.375 344.051 223.872 340.325L236.041 253.653C236.537 249.928 240.014 247.445 243.739 247.942L363.887 266.071C367.612 266.567 370.096 270.044 369.599 273.769L357.43 360.441C356.934 363.918 353.457 366.65 349.732 366.153Z"
        fill="#3B589D"
      />
      <path
        d="M345.486 350.218L225.338 332.088C221.612 331.592 219.129 328.115 219.626 324.39L231.794 237.718C232.291 233.993 235.768 231.509 239.493 232.006L359.641 250.135C363.366 250.632 365.85 254.109 365.353 257.834L353.184 344.506C352.688 347.982 349.211 350.714 345.486 350.218Z"
        fill="white"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M341.551 340.354L234.148 323.58C231.112 323.175 229.088 320.341 229.493 317.305L239.411 246.663C239.816 243.627 242.65 241.603 245.686 242.008L353.088 258.782C356.125 259.187 358.149 262.021 357.744 265.057L347.826 335.699C347.421 338.533 344.587 340.759 341.551 340.354Z"
        fill="#FEF4F3"
      />
      <path
        d="M423.477 98.972L442.462 117.956C443.727 119.222 445.499 119.981 447.018 119.981H494.605V75.4314H421.199V94.1626C421.705 96.1876 422.212 97.7064 423.477 98.972Z"
        fill="#F1F3F9"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M464.702 95.6531L486.977 95.6531L486.977 82.7437L464.702 82.7437L464.702 95.6531Z"
        fill="white"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M435.909 95.6531L458.184 95.6531L458.184 82.7437L435.909 82.7437L435.909 95.6531Z"
        fill="white"
        stroke="#D6DCE8"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M2.53125 386.774H626.175"
        stroke="#CDD6E1"
        strokeWidth="4.30732"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M218.18 384.75H184.008L185.527 380.954L189.07 371.335L192.108 362.982L195.652 353.363L198.183 346.782C198.689 345.516 199.955 344.504 201.22 344.504C202.486 344.504 203.752 345.263 204.258 346.782L206.789 353.363L210.333 362.982L213.37 371.335L216.914 380.954L218.18 384.75Z"
        fill="white"
        stroke="#FDBEBA"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
      />
      <path
        d="M210.343 362.982H192.129L195.552 353.616H206.871L210.343 362.982Z"
        fill="#FDBEBA"
      />
      <path
        d="M216.903 380.954H185.516L189.059 371.335H213.359L216.903 380.954Z"
        fill="#FDBEBA"
      />
      <path
        d="M218.18 384.751H183.755C182.743 384.751 181.73 383.992 181.73 382.726C181.73 381.713 182.49 380.701 183.755 380.701H218.18C219.193 380.701 220.205 381.46 220.205 382.726C220.205 383.992 219.446 384.751 218.18 384.751Z"
        fill="white"
        stroke="#FDBEBA"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
      />
      <path
        d="M405.441 384.75H371.27L372.788 380.954L376.332 371.335L379.37 362.982L382.913 353.363L385.444 346.782C385.951 345.516 387.216 344.504 388.482 344.504C389.748 344.504 391.013 345.263 391.519 346.782L394.051 353.363L397.594 362.982L400.632 371.335L404.176 380.954L405.441 384.75Z"
        fill="white"
        stroke="#FDBEBA"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
      />
      <path
        d="M397.605 362.982H379.391L382.814 353.616H394.133L397.605 362.982Z"
        fill="#FDBEBA"
      />
      <path
        d="M404.165 380.954H372.777L376.321 371.335H400.621L404.165 380.954Z"
        fill="#FDBEBA"
      />
      <path
        d="M405.442 384.751H371.017C370.005 384.751 368.992 383.992 368.992 382.726C368.992 381.713 369.752 380.701 371.017 380.701H405.442C406.455 380.701 407.467 381.46 407.467 382.726C407.467 383.992 406.708 384.751 405.442 384.751Z"
        fill="white"
        stroke="#FDBEBA"
        strokeWidth="2.87155"
        strokeMiterlimit="10"
      />
      <path
        d="M269.659 293.785C272.831 294.267 275.924 291.99 276.406 288.818C276.888 285.645 274.612 282.553 271.439 282.07C268.267 281.588 265.174 283.865 264.692 287.037C264.21 290.21 266.486 293.302 269.659 293.785Z"
        fill="#AAB2C5"
      />
      <path
        d="M314.565 300.608C317.738 301.09 320.83 298.814 321.312 295.641C321.794 292.469 319.518 289.376 316.345 288.894C313.173 288.412 310.08 290.688 309.598 293.861C309.079 297.278 311.393 300.126 314.565 300.608Z"
        fill="#AAB2C5"
      />
      <path
        d="M273.265 268.515L259.324 273.514L260.574 276.999L274.515 272.001L273.265 268.515Z"
        fill="#AAB2C5"
      />
      <path
        d="M317.615 275.16L315.387 278.117L327.215 287.031L329.444 284.074L317.615 275.16Z"
        fill="#AAB2C5"
      />
      <path
        d="M290.037 310.862C293.811 311.436 297.219 309.606 297.649 306.776C298.079 303.946 295.369 301.186 291.595 300.613C287.821 300.039 284.413 301.869 283.983 304.699C283.553 307.53 286.263 310.289 290.037 310.862Z"
        fill="#AAB2C5"
      />
      <path
        d="M197.086 411.014H533.357"
        stroke="#CDD6E1"
        strokeWidth="4.30732"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M87.7109 411.014H130.207"
        stroke="#CDD6E1"
        strokeWidth="4.30732"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
)
